<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center">
        <h4 class="mb-0">Usuarios</h4>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Rol</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Telèfono</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
            </tr>
          </thead>
          <tbody v-if="users.length !== 0">
            <tr v-for="user in users" :key="user.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <img src="/user.png" class="avatar avatar-sm me-3" alt="user1" />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ `${user.name} ${user.last_name}` }}</h6>
                    <!-- <p class="text-xs text-secondary mb-0">john@creative-tim.com</p> -->
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ user.rol }}</p>
                <p class="text-xs text-secondary mb-0">META</p>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ user.email }}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ user.phone }}</span>
              </td>
              <td class="align-middle">
                <div class="text-center">
                  <button @click="showAlert(user.id)" class="btn btn-link text-danger text-gradient px-3 mb-0">
                    <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                    Eliminar
                  </button>
                  <router-link :to="`/user-card/${user.id}`" class="btn btn-link text-dark px-3 mb-0">
                    <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i>Editar
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "authors-table",
  props: {
    users: {
      type: Array,
      request: true,
    },
  },
  computed: {
    ...mapGetters('auth', ["getAuthToken"]),
  },
  methods: {
    deleteUser(userID) {
      this.plain
        .delete(`/users/${userID}`, {
          headers: {
            'Authorization': this.getAuthToken
          }
        })
        .then(() => {
          this.$parent.deleteItemUser(userID)
          // console.log("USUARIO eliminado correctamente");
          // console.log(response.data);
        })
        .catch((error) => {
          console.log("Error al eliminar USUARIOS", error);
        });
    },
    showAlert(userID) {
      //deleteUser(user.id)
      this.$swal.fire({
        title: '¿Está seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteUser(userID);
          this.$swal.fire(
            '¡Eliminado!',
            'El Usuario ha sido eliminado.',
          )
        }
      })
    }
  },
};
</script>
